import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./preference-card.scss";
import Alert from "../Alert/Alert";
import Tabs from "../Tabs/Tabs";
import Card from "../Card/Card";
import BodyCopy from "../BodyCopy/BodyCopy";
import LoadingDots from "../LoadingDots/LoadingDots";

const PreferenceCard = ({
  heading,
  children,
  options,
  loading,
  selectedOption,
  hideToggle,
  handleToggle,
  error,
  errorTitle,
  errorMessage,
  className,
  ...rest
}) => {
  const tabs = options.map(opt => ({
    ...opt,
    selected: selectedOption && opt.id === selectedOption.id,
  }));
  return (
    <Card className={classnames("preference-card", className)} {...rest}>
      <div className="preference-card__inner">
        <div className="preference-card__content">
          <div className="u-content-container-medium">
            {heading && <h4 className="preference-card__title h700">{heading}</h4>}
            {children}
            <div className="preference-card__error" style={{ display: error ? "block" : "none" }}>
              <BodyCopy>
                <Alert type="error" inline>
                  {errorTitle}
                </Alert>
                {!!errorMessage && errorMessage}
              </BodyCopy>
            </div>
          </div>
        </div>
        {!hideToggle &&
          (loading ? (
            <LoadingDots className="preference-card__loading" />
          ) : (
            <Tabs
              className="preference-card__tabs"
              tabs={tabs}
              onTabLinkClick={tabId => handleToggle(options.find(({ id }) => id === tabId))}
            />
          ))}
      </div>
    </Card>
  );
};

const optionPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
});

PreferenceCard.propTypes = {
  heading: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.objectOf(PropTypes.node),
  ]),
  options: PropTypes.arrayOf(optionPropTypes).isRequired,
  selectedOption: optionPropTypes,
  hideToggle: PropTypes.bool,
  handleToggle: PropTypes.func.isRequired,
  className: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  errorTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.objectOf(PropTypes.node),
  ]),
  errorMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.objectOf(PropTypes.node),
  ]),
};

PreferenceCard.defaultProps = {
  errorTitle: "Oops!",
};

export default PreferenceCard;
